<template>
	<div class="home" id="top">
		<HeroBanner :image="require('../assets/img/tournage/tourhead-50.jpg')" />
		<section class="home-content container">
			<div class="about text-center mt-5">
				<h1>À propos de <span class="text-primary">Blanchard</span></h1>
				<p>
					Depuis sa création en 1981, l’entreprise <b>Blanchard</b>, située à Mortagne-au-Perche en Normandie, est présente sur le
					marché de la <b>mécanique générale et de précision</b>. Dotée de machines à commande numérique de dernière génération et
					d’une équipe expérimentée, <b>Blanchard</b> met à votre disposition ses compétences pour la réalisation de <b>vos besoins en
					usinage</b>, de la pièce unitaire à la moyenne série. 
				</p>
			</div>
			<ImageAndText
				id="equipements"
				v-animate="'fade-in'"
				:content="tournage"
			/>
			<ImageAndText
				:content="fraisage"
				v-animate="'fade-in'"
				reverse
			/>
		</section>
		<Services :image="require('../assets/img/fraisage/fraishead-70.jpg')" />
		<ActivityAreas id="activity-areas" />
		<Contact id="contact" />
	</div>
</template>

<script>
	import HeroBanner from '@/components/Banner/HeroBanner'
	import ImageAndText from '@/components/Commons/ImageAndText'
	import Services from '@/components/Home/Services'
	import Contact from '@/components/Home/Contact.vue'
	import ActivityAreas from '../components/Home/ActivityAreas.vue'

	export default {
		name: 'Home',

		components: {
			HeroBanner,
			ImageAndText,
			Services,
			Contact,
			ActivityAreas
		},

		data() {
			return {
				tournage: {
					image: require('../assets/img/tournage/tour2-crop.jpg'),
					imageAlt: "Blanchard tour commande numérique",
					title: "Équipements <span style='color: #d3031c;'>tournage CN</span>",
					description: "Dotée de <b style='color: #999999;'>quatre tours à commandes numériques Mazak</b>, <b style='color: #999999;'>Blanchard</b> est capable de produire rapidement une <b style='color: #999999;'>large gamme de produits de qualité</b>, vous permettant d’atteindre vos objectifs de <b style='color: #999999;'>réactivité</b>, de <b style='color: #999999;'>compétitivité</b> et de <b style='color: #999999;'>fiabilité</b>. L'équipe d'experts qui compose <b style='color: #999999;'>Blanchard</b> vous accompagnera dans tout le cycle de création de <b style='color: #999999;'>vos pièces métalliques et mécaniques</b>, du devis à la livraison."
				},
				fraisage: {
					image: require('../assets/img/fraisage/cn4-crop.jpg'),
					imageAlt: "Blanchard centre usinage",
					title: "Équipements <span style='color: #d3031c;'>fraisage CN</span>",
					description: "Jouissant de <b style='color: #999999;'>deux centres d'usinage à commandes numériques</b>, <b style='color: #999999;'>Blanchard</b> fournit en pièces métalliques et mécaniques de nombreux clients travaillant dans <b style='color: #999999;'>de multiples secteurs d’activités</b> : matériel de lutte incendie, machinisme agricole, bâtiment et travaux publics, filtration, convoyage industriel, sous-traitance industrielle, outillage, et bien plus encore."
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.home {
		margin-top: -115px;
	}
</style>
